
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { NotificationItemProps } from ".";
import { loading, create } from "store/notification";
import { AppMessage } from "components";

interface ApiNotificationCreateInputProps extends Omit<NotificationItemProps, "id"> {
}

type ApiNotificationCreateOutputProps = OutputBaseProps<{ item: NotificationItemProps; }, ApiNotificationCreateInputProps>

export const apiNotificationCreate = async (data: ApiNotificationCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiNotificationCreateOutputProps>("/api/notification/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};